import React from 'react';
import { TextType } from '../../../models/ContentManagementInterface';
import { contentNotSet } from '../../../services/TemplateUtils';
import InlineRichText from './InlineRichText';
import { webTextSx } from './webTextStyles';

interface TextBlockEditorProps {
  block: TextType;
  onChange: (props: TextType['properties']) => void;
}

/** A single rich-text body edited in place — no heading, paste or footnotes. */
export default function TextBlockEditor({ block, onChange }: TextBlockEditorProps) {
  const { content } = block.properties;
  return (
    <InlineRichText
      html={content?.content ?? ''}
      unset={contentNotSet(content)}
      onChange={(html) => onChange({ content: { ...content, content: html } })}
      placeholder="Add text"
      ariaLabel="Text"
      minLines={3}
      sx={webTextSx}
    />
  );
}
